import { Injectable, inject } from "@angular/core";

import { NoteService, INotesDialogService } from "@tylertech/notes-module";
import { IAggregate, ICardData, ICardAction, INote, ActionType } from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces";
import { AggregateActionResult } from "../services";

// TODO - why does this live here and not in library/notes
@Injectable()
export class NoteActionHandler implements IAggregateActionHandler
{
    private readonly $notesService = inject(NoteService);
    private readonly $notesDialogService = inject(INotesDialogService);


    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Notes;
    }

    execute(_aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        const add = !action.Model;
        const entity = {
            Id: cardData.Id,
            Type: action.content,
        };
        return this.$notesDialogService.show(entity, add, false, false).then((notes: INote[]) =>
        {
            if (notes)
            {
                action.Model = notes.length;
            }
            return false;
        });
    }

    load(_aggregate: IAggregate, cardData: ICardData, action: ICardAction): void
    {
        const entity = {
            Id: cardData.Id,
            Type: action.content,
        };
        this.$notesService.Get(entity)
            .then(x =>
            {
                action.Model = x.Result.length;
            });
    }
}
